import { useFeatureFlag } from '@ctw/shared/context/feature-flag-provider';
import { PatientRiskGaps } from './patient-risk-gaps';
import { PatientRiskGapsV2 } from './patient-risk-gaps-v2';

/**
 * Selector component that loads either patient-risk-gaps or patient-risk-gaps-v2
 * based on the ui-riskcapture-workflow-preview feature flag.
 */
export const PatientRiskGapsUiSelector = () => {
  const riskCaptureWorkflowPreviewEnabled = useFeatureFlag('ui-riskcapture-workflow-preview');

  if (riskCaptureWorkflowPreviewEnabled) {
    return <PatientRiskGapsV2 testId="patient-risk-gaps-v2" />;
  }

  return <PatientRiskGaps testId="patient-risk-gaps-v1" />;
};
